import adminRoutes from './admin-routes';
import AdminHotelPanel from './admin-hotel-panel/admin-hotel-panel-component';
import AdminService from './admin-service';
import AdminHotelEditModule from './admin-hotel-edit/admin-hotel-edit-module';
import AdminHotelListModule from './admin-hotel-list/admin-hotel-list-module';
import AdminHotelMergeModule from './admin-hotel-merge/admin-hotel-merge-module';
import AdminHotelViewModule from './admin-hotel-view/admin-hotel-view-module';
import AdminNavigationModule from './admin-navigation/admin-navigation-module';
import AdminFaxModule from './admin-fax/admin-fax-module';

import './admin.scss';

angular
    .module('app.admin.states', []);

const MODULE_NAME = 'App.admin';
const module = angular
    .module(MODULE_NAME, [
        'app.admin.states',
        AdminNavigationModule,
        AdminHotelListModule,
        AdminHotelViewModule,
        AdminHotelMergeModule,
        AdminHotelEditModule,
        AdminFaxModule,
    ])
    .directive(AdminHotelPanel.DIRECTIVE_NAME, AdminHotelPanel)
    .service('adminService', AdminService)
    .config(adminRoutes);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-module.js